export default [
  {
    id: 'product_c893b8b4',
    name: 'Appels'
  },
  {
    id: 'product_15ed99a3',
    name: 'Bananen'
  },
  {
    id: 'product_dad54e52',
    name: 'Kiwi'
  },
  {
    id: 'product_7e4cd9b3',
    name: 'Mango'
  },
  {
    id: 'product_15f497eb',
    name: 'Aardappels'
  },
  {
    id: 'product_83de30e1',
    name: 'Komkommer'
  },
  {
    id: 'product_a3a3aed3',
    name: 'Paprika'
  },
  {
    id: 'product_2a524b45',
    name: 'Tomaat'
  },
  {
    id: 'product_3a6b1190',
    name: 'Kip'
  },
  {
    id: 'product_c34102d4',
    name: 'Gehakt'
  },
  {
    id: 'product_cc918d84',
    name: 'Varkenshaas'
  },
  {
    id: 'product_f1a60800',
    name: 'Kogelbiefstuk'
  },
  {
    id: 'product_6bafd980',
    name: 'Appelsap'
  },
  {
    id: 'product_1e8641fc',
    name: 'Spa Rood'
  },
  {
    id: 'product_57d977ef',
    name: 'Koffie'
  },
  {
    id: 'product_d214b1ec',
    name: 'Melk'
  }
]



// WEBPACK FOOTER //
// ./src/data/products.js